// useChatScroll.ts
import { useEffect, useRef } from "react";

export default function useChatScroll<T extends HTMLElement>(dep: any[]) {
  const ref = useRef<T>(null);

  useEffect(() => {
    if (ref.current) {
      ref.current.scrollTo({
        top: ref.current.scrollHeight,
        behavior: "smooth",
      });
    }
  }, [dep]);

  return ref;
}
